import {Lamp} from "./lamp";
import {serialize} from "@angular/compiler/src/i18n/serializers/xml_helper";
/**
 * Created by jmulder on 13/11/16.
 */

export const OVERBOOST: number = 819;
export const DEFAULT_POWER: number = 720; // value for 1 kW 'old' driver
export const DEFAULT_POWER_SCALAR = 880;
export const DEFAULT_POWER_ON_VALUE = 100;

export const DRIVERS: Object = {
  0: {
    driver: 'V1', label: 'V1, 1.0 kW', overboost: 819, default: 720, powerOnValue: 0
  },
  1: {
    driver: 'V1', label: 'V1, 1.2 kW', overboost: 700, default: 640, powerOnValue: 0
  },
  2: {
    driver: 'V2', label: 'V2, 500 W', overboost: 950, default: DEFAULT_POWER_SCALAR, powerOnValue: DEFAULT_POWER_ON_VALUE
  },
  3: {
    driver: 'V2', label: 'V2, 1.0 kW', overboost: 950, default: DEFAULT_POWER_SCALAR, powerOnValue: DEFAULT_POWER_ON_VALUE
  },
  4: {
    driver: 'V2', label: 'V2, 1.5 kW', overboost: 950, default: DEFAULT_POWER_SCALAR, powerOnValue: DEFAULT_POWER_ON_VALUE
  },
  5: {
    driver: 'V2', label: 'V2, 1.8 kW', overboost: 950, default: DEFAULT_POWER_SCALAR, powerOnValue: DEFAULT_POWER_ON_VALUE
  },
  6: {
    driver: 'V2', label: 'V2, 2.0 kW', overboost: 950, default: DEFAULT_POWER_SCALAR, powerOnValue: DEFAULT_POWER_ON_VALUE
  },
  7: {
    driver: 'Relay', label: 'RS485 Relay', overboost: 0, default: 0, powerOnValue: 0
  }
};

export class Psu {
    static fromJson({$key, description, defaultPower, power, overboost, percentagePower, installationDate, soll, ist, serialNr, burnTime, powerConsumption,
                    outVoltage12, outVoltage34, current, inputVoltage, driverTemp, caseTemp, led1temp, led2temp, powerOnValue, statusReport, errorLog, errorStatus, factoryPower }) {
        return new Psu($key, description, defaultPower, power, overboost, percentagePower, installationDate, soll, ist, serialNr, burnTime, powerConsumption,
          outVoltage12, outVoltage34, current, inputVoltage, driverTemp, caseTemp, led1temp, led2temp, powerOnValue, statusReport, errorLog, errorStatus, factoryPower);
    }

    static fromJsonArray(json : any[]) : Psu[] {
        return json.map(Psu.fromJson);
    }

    static toPsuArray(json: any[]) : Psu[] {
        var psuArr: Psu[] = [];

        //console.log("toPsuArray json: ", json);

        for (let key in json) {
            var value = json[key];

            let psu = <Psu>({
                $key: key,
                description: value.description,
                defaultPower: value.defaultPower,
                power: value.power,
                overboost: value.overboost,
                installationDate: value.installationDate,
                soll: value.soll,
                ist: value.ist,
                serialNr: value.serialNr,
                burnTime: value.burnTime,
                powerConsumption: value.powerConsumption,
                outVoltage12: value.outVoltage12,
                outVoltage34: value.outVoltage34,
                current: value.current,
                inputVoltage: value.inputVoltage,
                driverTemp: value.driverTemp,
                caseTemp: value.caseTemp,
                led1Temp: value.led1temp,
                led2Temp: value.led2temp,
                powerOnValue: value.powerOnValue,
                statusReport: value.statusReport,
                errorStatus: value.errorStatus,
                errorLog: value.errorLog,
                factoryPower: value.factoryPower
            });
            psuArr.push(psu);
        }

        return psuArr;

    }

  constructor(
    public $key: string,                // address byte starting at 0 for first psu in light pole
    public description: string,         // description of the PSU
    public defaultPower: number,        // default power setting (training level)
    public power: number,               // current power setting
    public overboost: number,           // overboost power setting
    public percentagePower: number,     // current wattage (0=off)
    public installationDate: string,    // date of installation
    public soll: number,                // soll value of lamp as percentage
    public ist: number,                 // ist value of lamp as percentage
    public serialNr: string,            // serial number
    public burnTime: number,            // burn time
    public powerConsumption: number,    // power consumption in Watt
    public outVoltage12: number,        // output voltage channel 1, 2 in V
    public outVoltage34: number,        // output voltage channel 3, 4 in V
    public current: number,             // output current in mA
    public inputVoltage: number,        // input voltage in V
    public driverTemp: number,          // driver temperature in C
    public caseTemp: number,            // case temperature in C
    public led1Temp: number,            // driver temperature in C
    public led2Temp: number,            // case temperature in C
    public powerOnValue: number,        // newest
    public statusReport: string,        // running state of driver
    public errorLog: string,            // history of errors that occurred
    public errorStatus: string,         // current (real-time) errors
    public factoryPower: number         // PWM value indicating the factory power setting of the PSU
  ) {
  }
}
